module.exports = __webpack_public_path__ + "assets/a1f702f8fcf310e8147dfeee6b1dda38.svg";